export default class Anchors {


	offsetTop = [];

	constructor() {
		Anchors.displayAnchors();
		Anchors.smoothScroll();
		Anchors.detectCurrent();
	}

	static displayAnchors() {
		const trigger = '[data-trigger="anchors"]';
		const triggerPosition = ($("#main").offset().top - 200);
		$(window).scroll(() => {
			const top = $(window).scrollTop();
			if (top > triggerPosition) {
				if (!$(trigger).hasClass('active')) {
					$(trigger).addClass('active');
				}
			} else {
				$(trigger).removeClass('active');
			}
		});
	}

	static smoothScroll() {
		$('[data-trigger="anchors"] a').click(function() {
			$('[data-trigger="anchors"] a').removeClass('active');
			$(this).addClass('active');

			const navbarHeight = $('.navbar').height();
			const target = $(this).attr('href');
			if (target.length) {
				const scrollSize = $(target).offset().top - navbarHeight;
				$('html,body').animate({
					scrollTop: scrollSize
				}, 1000);
			}
			return false;
		});
	}

	static detectCurrent() {
		const anchorsList = [];
		$('[data-trigger="anchors"] a').each(function() {
			anchorsList.push($(this).data('target'));
		});

		$(window).on('resize scroll', function() {
			for(const anchor of anchorsList) {
				const elementTop = $('#'+anchor).offset().top;
				const viewportTop = $(window).scrollTop();

				if((elementTop + 200) >= viewportTop) {
					$('[data-trigger="anchors"] a').removeClass('active');
					$('[data-target="'+anchor+'"]').addClass('active');
					break;
				}
			}
		});
	}
}
